export const servicerEpAwareApi = {
  dashboardSso: "service-provider/ep-aware/dashboard-sso",
};
